/**
 * @typedef {{
 *  metadata: { id: string }
 *  rawCustomChart: { source: string, url: string }
 * }} CustomChartContract
 */

/**
 * @typedef {{
 *  source: string
 *  id: string
 * }} StoredCustomChart
 */